import { Injectable } from '@angular/core';
import { AbstractEntityStore } from '@pf/shared-services';
import { PFWmsEntities } from '@pf/shared-common';
import { ShipmentRead } from '../../entities/shipment.dto';

@Injectable()
export class ShipmentStore extends AbstractEntityStore<ShipmentRead> {
    constructor() {
        super(PFWmsEntities.Shipment);
    }
}
